import { render } from "./EditCoupon.vue?vue&type=template&id=d5af6412&scoped=true"
import script from "./EditCoupon.vue?vue&type=script&lang=js"
export * from "./EditCoupon.vue?vue&type=script&lang=js"

import "./EditCoupon.vue?vue&type=style&index=0&id=d5af6412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5af6412"]])

export default __exports__